import React, { useState, useEffect } from "react";
import { Card } from "../../../common";
import CompanyLogo from "../../../../assets/images/companylogo.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as Pen } from "../../../../assets/icons/pen.svg";
import { ReactComponent as AlertIcon } from "../../../../assets/icons/alert_icon.svg";
import {
  useGetCompanyQuery,
  useRequestVerificationMutation,
} from "../../../../store/Company/companyApiSlice";
import { RequestVerificationAction } from "./RequestVerificationAction";
import { CommonToast } from "../../../common/Toast";

const userRoles = {
  "CL": "Claimer",
  "AD": "Admin",
  "ED": "Editor"
}

export const CompanyCard = ({ company: company }) => {
  const companyID = company.companyID;
  const role = company.role;
  const navigate = useNavigate();
  const [currentViews, setCurrentViews] = useState(0);
  const [details, setDetails] = useState(0);
  const [percentageChange, setPercentageChange] = useState(0);
  const [isPositiveChange, setIsPositiveChange] = useState(false);
  const [IndustryDe, setIndustry] = useState({});
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  // TIP-491 — member-only "Request verification" action.
  const [requestVerification, { isLoading: isRequestingVerification }] =
    useRequestVerificationMutation();
  const [verificationRequested, setVerificationRequested] = useState(false);

  const handleRequestVerification = async (e) => {
    e?.stopPropagation?.();
    try {
      await requestVerification({ companyID: companyID?.companyID, token }).unwrap();
      setVerificationRequested(true);
      CommonToast.success("Verification requested — our team will review it shortly.");
    } catch (err) {
      CommonToast.error(
        err?.data?.detail || "Couldn't request verification. Please try again."
      );
    }
  };

  const handleUpsell = (e) => {
    e?.stopPropagation?.();
    if (companyID?.companyID) navigate(`/membership/${companyID.companyID}`);
  };

  // Calling Api multiple times because it is written inside map, need to work on this fix
  const { data, refetch } = useGetCompanyQuery({
    companyId: companyID?.companyID,
    token,
  });
  useEffect(() => {
    if (currentEditingCompany) {
      setIndustry(currentEditingCompany?.industry);
    }
  }, [currentEditingCompany]);

  let count = "";

  useEffect(() => {
    //progress bar percentage
    let total = 15;
    let subtotal = 0;
    if (data != undefined) {
      if (data?.company_description != null || data?.number_of_employees != null) {
        subtotal = subtotal + 1;
      }
      if (data?.facebook != null || data?.twitter != null || data?.linkedin != null || data?.website != null || data?.instagram != null) {
        subtotal = subtotal + 1;
      }
      if (data?.authorizedSignDetails?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.companyKeyPersonnel?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.relatedEntity?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.ownershipCompany?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.insuranceDetails?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.bankDetails?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.companyAddress?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.businessRelation?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.trade_license != '' && data?.trade_license != null && data?.trade_license != undefined) {
        subtotal = subtotal + 1;
      }
      if (data?.logo != '' && data?.logo != null && data?.logo != undefined) {
        subtotal = subtotal + 1;
      }
      if (data?.banner != '' && data?.banner != null && data?.banner != undefined) {

        subtotal = subtotal + 1;
      }
      // if (data?.MOA !== '' && data?.MOA != null && data?.MOA != undefined) {

      //   subtotal = subtotal + 1;
      // }
      // if (data?.VAT_certificate !== '' && data?.VAT_certificate != null && data?.VAT_certificate !== undefined) {

      //   subtotal = subtotal + 1;
      // }
      if (data?.financialDetails?.length > 0) {
        subtotal = subtotal + 1;
      }
      if (data?.sub_industry?.length > 0) {
        subtotal = subtotal + 1;
      }
      let percentDetails = (subtotal / total) * 100;
      setDetails(parseInt(percentDetails));
    }
  }, [details, data]);
  useEffect(() => {
    const fetchProfileViews = () => {
      const currentWeekViews = 5965;
      const previousWeekViews = 800;

      setCurrentViews(currentWeekViews);
      const change =
        ((currentWeekViews - previousWeekViews) / previousWeekViews) * 100;
      const roundedChange = Math.round(change * 10) / 10;
      setPercentageChange(roundedChange);

      setIsPositiveChange(change >= 0);
    };

    fetchProfileViews();
  }, []);

  return (
    <Card classes="max-w-sm w-full">
      <div
        className="rounded-lg border border-input cursor-pointer"
        onClick={companyID.companyID ? (e) => {
          e.stopPropagation();
          navigate(`/search/${companyID.companyID}`);
        } : null}
      >
        <div className="p-2 text-white bg-company rounded-t-lg relative">
          {/* Edit button */}
          <button
            className="absolute top-2 right-2 bg-white rounded-full p-2"
            onClick={companyID.companyID ? (e) => {
              e.stopPropagation();
              navigate(`/edit/${companyID.companyID}`);
            } : null}
          >
            <Pen className="text-primary" />
          </button>
          {/* <div style={{ "margin": "-5%" }}> */}
          {company?.endorsements?.message === null && (
            <AlertIcon title="there are new endorsement(s)" className="w-10 h-10" style={{ margin: "-5%" }} />
          )}
          {/* </div> */}
          <div className="flex flex-col items-center mt-10 mx-1">
            <img src={CompanyLogo} alt="business logo" className="w-20 h-20" />
            <div class="mt-4 mb-2 text-lg font-semibold max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
              {companyID.registered_company_name}
            </div>
          </div>
        </div>
        <div className="p-4 bg-secondary rounded-b-lg">
          <div className="hidden justify-between items-center">
            <p className=" text-left text-secondarytwo text-f14">
              This week’s profile views <br />{" "}
              <span className="text-f16 font-semibold">{currentViews}</span>
            </p>
            <p className=" text-f12 font-bold ">
              <span
                className={
                  isPositiveChange
                    ? "text-success flex items-center"
                    : "text-red-500 flex items-center"
                }
              >
                {isPositiveChange ? (
                  <span className="text-success mr-2">
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.43529 0.5C4.88915 0.5 5.30929 0.731145 5.54976 1.10293L5.59545 1.17924L8.74541 6.61402L8.77291 6.66992C8.85161 6.86453 8.88315 7.075 8.86497 7.28414C8.84678 7.49327 8.77939 7.69514 8.66829 7.87325C8.55719 8.05136 8.40554 8.20067 8.22571 8.30898C8.04589 8.41729 7.843 8.48153 7.63361 8.49645L7.54532 8.5H1.33414L1.3124 8.49867L1.26271 8.49956C1.06511 8.48939 0.872258 8.43529 0.698196 8.3412C0.524135 8.24711 0.373243 8.11539 0.2565 7.95563L0.208141 7.88465C0.102482 7.71864 0.0349471 7.53128 0.0103981 7.33604C-0.0141508 7.1408 0.00489751 6.94254 0.0661716 6.75555L0.0981148 6.66948L0.124734 6.61402L3.27114 1.18678C3.38622 0.978717 3.55493 0.80528 3.75974 0.684503C3.96455 0.563725 4.19797 0.500016 4.43574 0.5H4.43529Z"
                        fill="#269758"
                      />
                    </svg>
                  </span>
                ) : (
                  <span className="text-red-500 mr-2">
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.43529 0.5C4.88915 0.5 5.30929 0.731145 5.54976 1.10293L5.59545 1.17924L8.74541 6.61402L8.77291 6.66992C8.85161 6.86453 8.88315 7.075 8.86497 7.28414C8.84678 7.49327 8.77939 7.69514 8.66829 7.87325C8.55719 8.05136 8.40554 8.20067 8.22571 8.30898C8.04589 8.41729 7.843 8.48153 7.63361 8.49645L7.54532 8.5H1.33414L1.3124 8.49867L1.26271 8.49956C1.06511 8.48939 0.872258 8.43529 0.698196 8.3412C0.524135 8.24711 0.373243 8.11539 0.2565 7.95563L0.208141 7.88465C0.102482 7.71864 0.0349471 7.53128 0.0103981 7.33604C-0.0141508 7.1408 0.00489751 6.94254 0.0661716 6.75555L0.0981148 6.66948L0.124734 6.61402L3.27114 1.18678C3.38622 0.978717 3.55493 0.80528 3.75974 0.684503C3.96455 0.563725 4.19797 0.500016 4.43574 0.5H4.43529Z"
                        fill="#DC2626"
                      />
                    </svg>
                  </span>
                )}
                {percentageChange}%
              </span>
            </p>
          </div>
          <hr className="border-t border-gray-300 my-4" />
          <div className="flex justify-between items-center text-f14 cursor-pointer">
            <div className="text-left text-primary text-f14">
              <span>Profile Completion</span> <br />
              <div className="flex gap-3 items-center justify-start mt-2 w-48">
                <div className="bg-bar h-2 rounded-full overflow-hidden  relative w-full">
                  <div
                    className="bg-primary h-full transition-all"
                    style={{ width: `${details}%` }}
                  ></div>
                </div>
                <span className="">{details}%</span>
              </div>
            </div>
            <div className="text-left text-primary text-f14">
              <span>Your Role</span> <br />
              <div className="bg-white rounded-md px-3 py-1 inline-block mt-2">
                {/* Note: This is role change we made this temp change */}
                <span style={{ color: "#5925DC" }} className="text-f12 font-semibold">{userRoles[role] === "Admin" ? "Manager" : userRoles[role] === "Claimer" ? "Admin" : userRoles[role]}</span>
              </div>
            </div>
          </div>
          {/* TIP-491 — verification is a free, member-only request. */}
          <div className="mt-4 flex justify-between items-center" onClick={(e) => e.stopPropagation()}>
            <span className="text-secondarytwo text-f12">Verification</span>
            <RequestVerificationAction
              profileStatus={data?.profile_status}
              requested={verificationRequested}
              submitting={isRequestingVerification}
              onRequest={handleRequestVerification}
              onUpsell={handleUpsell}
            />
          </div>
        </div>
      </div>
    </Card>

  );
};
